<template>
  <div>
    <div class="friendurls">
      <div class="main">
        <div class="title">友情链接</div>
        <div class="content">
          <a href="http://www.dem-league.org.cn/" target="_blank">
            <span>
              <img
                src="https://h5.v2gogo.com/lib/image/minmeng-pc/square.png"
                height="16"
                border="0/"
              >
            </span>
            <span>中国民主同盟</span>
          </a>

          <a href="http://www.gzswtzb.org.cn/" target="_blank">
            <span>
              <img
                src="https://h5.v2gogo.com/lib/image/minmeng-pc/square.png"
                height="16"
                border="0/"
              >
            </span>
            <span>贵州统一战线</span>
          </a>

          <a href=" http://www.gzszx.gov.cn/" target="_blank">
            <span>
              <img
                src="https://h5.v2gogo.com/lib/image/minmeng-pc/square.png"
                height="16"
                border="0/"
              >
            </span>
            <span>贵州政协网</span>
          </a>

          <a href="http://www.gzswtzb.org.cn/dbbanner/xxxy/" target="_blank">
            <span>
              <img
                src="https://h5.v2gogo.com/lib/image/minmeng-pc/square.png"
                height="16"
                border="0/"
              >
            </span>
            <span>学习新语</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blogroll',
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.friendurls {
  background: #e7f4ff;
  color: #333;
  margin-top: 20px;
  line-height: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;
  font-size: 12px;
  .title {
    font-weight: bold;
    font-size: 16px;
    font-family: 宋体;
  }
  a {
    margin-right: 30px !important;
    margin: 0;
    padding: 0;
    border: 0;
    color: #3c3c3c;
    font-size: 14px;
    font-family: 宋体;
  }
  img {
    vertical-align: middle;
  }
}
a {
  margin-right: 30px;
}
.main {
  width: 1200px;
  padding: 0;
  margin: 0 auto;
  position: relative;
}
span:hover {
  color: #2386e2;
  text-decoration: underline;
}

</style>
